import React from 'react';

import HelpPageFooterNotice from '../components/helpPageFooterNotice';

const ManageTripGroupsHelp: React.FC = () => {
  return (
    <>
      <h1>Manage Trip Groups</h1>
      <p>
        The Manage Trip Groups page allows you to view all the Trip Groups that
        have been created in your account. You can search for Trip Groups
        specifically by Name, Customer ID, or by Trip Groups that have Custom
        Alert Settings enabled.
      </p>
      <h2>Search Filters</h2>

      <p>
        The default search filters for an account will include the Name,
        Customer ID, and Custom Alert Settings. Depending on your account setup,
        additional filters may be present such as VIP Flag, Country ID, or PCC.
      </p>
      <p>
        <strong>Name:</strong> A free text field that you can use to search for
        a Trip Group specifically by how it is named. By default, this will be
        the Customer ID value used upon importing your trips, but this can be
        overridden to display a more user-friendly name by using the Edit Trip
        Group page.
      </p>
      <p>
        <strong>Customer ID:</strong> The Customer ID is the value assigned to a
        Trip Group when trips are imported into your account. You can search for
        Trip Groups by using this field as a dropdown menu and selecting the
        desired Customer ID or by typing a known Customer ID value.
      </p>
      <p>
        <strong>Custom Alert Settings:</strong> This field defaults to the value
        “Any”, which will display all Trip Groups, regardless of if the alert
        settings have been overridden from the account default values. You can
        select “True” to display any Trip Groups that have been updated to have
        custom alert settings or “False” for Trip Groups that have inherited the
        account default settings.
      </p>

      <h2>Column Headers</h2>
      <p>
        <strong>Lineage:</strong> This displays the full lineage of a Trip Group
        that has been created in your account. At a minimum, this will include
        the CUSTOMER_ID value but may contain additional attributes depending on
        your account setup, such as VIP_FLAG, COUNTRY_ID, PCC, etc...
        <br />
        You can click on the header value to sort your Trip Groups by ascending
        or descending values based on the CUSTOMER_ID.
      </p>
      <p>
        <strong>Name:</strong> This is the name of Trip Group displayed in the
        Trip Center UI. By default, this will be the CUSTOMER_ID value assigned
        to a Trip Group when imported into your account. You can update this to
        a user-friendly name on the EDIT TRIP GROUP page.
        <br />
        You can click on the header value to sort your Trip Groups by ascending
        or descending values based on the Name.
      </p>
      <p>
        <strong>Created (UTC):</strong> This column displays the date/time stamp
        for when a Trip Group was created in your account in UTC. You can click
        on the header value to sort your Trip Groups by ascending or descending
        values based on creation date/time.
      </p>
      <p>
        <strong>Custom Alert Settings:</strong> A green check mark will be
        displayed if an individual Trip Group has been overridden from the
        default settings for your account. A red square with an X will be
        displayed if a Trip Group is inheriting the settings from the account
        default.
      </p>
      <p>
        <strong>Trip Assist Issues:</strong> A green check mark will be
        displayed if an individual Trip Group has Trip Assist enabled. A red
        square with an X will be displayed if a Trip has Trip Assist disabled.
      </p>
      <p>
        <strong>Agent Trip Alerts:</strong> A green check mark will be displayed
        if an individual Trip Group has Agent Email Notifications enabled. A red
        square with an X will be displayed if a Trip Group has Agent Email
        Notifications disabled.
      </p>
      <p>
        <strong>Traveler Trip Alerts:</strong> A green check mark will be
        displayed if an individual Trip Group has Traveler Trip Alerts enabled.
        A red square with an X will be displayed if a Trip has Traveler Trip
        Alerts is disabled.
      </p>
      <h2>View/Edit Trip Group</h2>

      <p>
        You can edit or view an individual Trip Group’s configuration by
        clicking on the value present in the “Lineage” column.
      </p>
      <HelpPageFooterNotice />
    </>
  );
};
export default ManageTripGroupsHelp;
